import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ILoader, ILoaderService } from './loader.types';

/**
 * LoaderService
 */
@Injectable({
	providedIn: 'root'
})
export class LoaderService implements ILoaderService {
	constructor(router: Router) {
		// clear alert message on route change
		router.events.subscribe((event: NavigationStart) => {
			if (event instanceof NavigationStart) {
				if (this.keepAfterNavigationChange) {
					// only keep for a single location change
					this.keepAfterNavigationChange = false;
				} else {
					// clear alert
					this.subject.next();
				}
			}
		});
	}

	private subject: Subject<ILoader> = new Subject<ILoader>();
	private keepAfterNavigationChange: boolean = false;

	public setLoadingStatus(
		isLoading: boolean = false,
		progress: number = 0,
		loaderType: string = 'indeterminate',
		color: string = 'warn',
		keepAfterNavigationChange: boolean = false
	): void {
		this.keepAfterNavigationChange = keepAfterNavigationChange;
		this.subject.next({ isLoading, progress, loaderType, color });
	}

	public getLoadingStatus(): Observable<ILoader> {
		return this.subject.asObservable();
	}
}
